// extracted by mini-css-extract-plugin
module.exports = {"upload":"ImageUpload_upload__2_vuf","upload__loader":"ImageUpload_upload__loader__1U2tJ"};